function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.893 3.142v1.904L14.041.898a.75.75 0 111.06 1.06l-4.147 4.149h1.903a.75.75 0 010 1.5H9.143a.75.75 0 01-.75-.767V3.142a.75.75 0 111.5 0zM.9 14.041a.75.75 0 101.06 1.06l4.148-4.148v1.904a.75.75 0 001.5 0V9.142a.747.747 0 00-.75-.75H3.143a.75.75 0 000 1.5h1.904L.899 14.041z",
  fill: "currentColor"
})));